//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'VehicleGallery',
    props: {
        images: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            currentIndex: 0,
            photoSwipeOpen: false,
            showCarousel: true,
            canUsePhotoSwipe: false,
            photoSwipeOptions: {
                index: 0,
                shareEl: false,
                history: false,
                focus: false
            }
        }
    },
    computed: {
        hasImages() {
            return this.images && this.images.length > 0;
        },
        photoSwipeItems() {
            return this.images.map((image, index) => ({
                src: this.getImageUrl(image.name),
                w: 1024,
                h: 1024,
                title: `Imagen ${index + 1}`
            }));
        }
    },
    mounted() {
        // Quick component check
        this.checkComponents();
    },
    methods: {
        checkComponents() {
            // Simple sync check
            try {
                this.showCarousel = !!this.$options.components['ssr-carousel'];
                this.canUsePhotoSwipe = !!this.$options.components['vue-picture-swipe'];
            } catch (e) {
                this.showCarousel = false;
                this.canUsePhotoSwipe = false;
            }
        },
        
        getImageUrl(imageName) {
            if (!imageName) return '';
            
            let baseUrl = '/storage/vehicles/large/';
            
            if (this.$store && this.$store.state && this.$store.state.large_url) {
                baseUrl = this.$store.state.large_url;
            }
            
            return baseUrl + imageName;
        },
        
        getImageStyle(imageName) {
            return {
                'background-image': `url(${this.getImageUrl(imageName)})`
            };
        },
        
        getCurrentImageUrl() {
            if (!this.hasImages) return '';
            return this.getImageUrl(this.images[this.currentIndex].name);
        },
        
        handleImageClick(index) {
            if (this.canUsePhotoSwipe) {
                this.photoSwipeOptions.index = index;
                this.photoSwipeOpen = true;
            } else {
                this.currentIndex = index;
            }
        },
        
        closePhotoSwipe() {
            this.photoSwipeOpen = false;
        },
        
        nextImage() {
            this.currentIndex = (this.currentIndex + 1) % this.images.length;
        },
        
        prevImage() {
            this.currentIndex = this.currentIndex > 0 ? this.currentIndex - 1 : this.images.length - 1;
        },
        
        handleImageError(event) {
            console.warn('Error loading image:', event.target.src);
        }
    }
}
